import { AutocompleteInput, Button, Create,  Datagrid, DateField, Edit, EditButton, FormTab, List, NumberField, NumberInput, ReferenceField, ReferenceInput, required, SelectInput, Show, ShowButton, SimpleForm, SimpleShowLayout, TabbedForm, TextField, TextInput, useGetList, useRecordContext, useUpdateMany, useNotify, BooleanInput, BooleanField, FunctionField, ReferenceManyField, useListContext } from "react-admin";
import { useWatch } from "react-hook-form";


const PositionFilters = [
    <TextInput label="Code" source="code" alwaysOn />,
    <ReferenceInput source="company_id" reference="companies" validate={required()} alwaysOn><SelectInput optionText="full_name" optionValue="id" /></ReferenceInput>,
    <ReferenceInput source="position_category_id" reference="position_category" validate={required()} alwaysOn><SelectInput optionText="description" optionValue="id" /></ReferenceInput>,
    <TextInput label="Department" source="department" />,
    <TextInput label="Name" source="name" />,
    <SelectInput source="currency" choices={[
        { id: 'INR', name: 'INR' },
        { id: 'USD', name: 'USD' },
        { id: 'JPY', name: 'JPY' },
    ]} label="Currency" />
];

export const PositionList = () => (
    <List filters={PositionFilters} emptyWhileLoading>
        <Datagrid bulkActionButtons={false}>
            <TextField source="id" validate={required()} />
            <TextField source="code" validate={required()} />
            <TextField source="name" validate={required()} />
            <TextField source="department" validate={required()} />
            <TextField source="man_months" validate={required()} />
            <TextField source="rate_per_month" validate={required()} />
            <TextField source="total_contract_value" validate={required()} />
            <ReferenceField source="company_id" reference="companies"><TextField source="name" /></ReferenceField>
            <ReferenceField source="position_category_id" reference="position_category"><TextField source="description" /></ReferenceField>
            <ShowButton label="View"/>
            <EditButton label="Edit"/>
        </Datagrid>
    </List>
);

const ContractTypeField = ({isView = false}) => isView ? (<FunctionField render={record => 
    record.contract_type === 'add-0' ? 'Original Contract' :
    record.contract_type === 'add-1' ? 'Contract Addendum-1' :
    record.contract_type === 'add-2' ? 'Contract Addendum-2' :
    record.contract_type === 'add-3' ? 'Contract Addendum-3' :
    record.contract_type === 'add-4' ? 'Contract Addendum-4' :
    record.contract_type === 'add-5' ? 'Contract Addendum-5' :
    record.contract_type === 'add-6' ? 'Contract Addendum-6' : ""
     } /> ):
     (<SelectInput source="contract_type" choices={[
        { id: 'add-0', name: 'Original' },
        { id: 'add-1', name: 'Addendum-1' },
        { id: 'add-2', name: 'Addendum-2' },
        { id: 'add-3', name: 'Addendum-3' },
        { id: 'add-4', name: 'Addendum-4' },
        { id: 'add-5', name: 'Addendum-5' },
        { id: 'add-6', name: 'Addendum-6' },
    ]} defaultValue='add-0' />
     );

export const PositionCreate = () => (
    <Create>
        <TabbedForm>
            <FormTab label="Position Details">
            <BooleanInput source="active" defaultValue={true} />
                <ReferenceInput source="company_id" reference="companies" validate={required()}><SelectInput optionText="full_name" optionValue="id" /></ReferenceInput>
                <ReferenceInput source="position_category_id" reference="position_category" validate={required()}><SelectInput optionText="description" optionValue="id" /></ReferenceInput>
                <TextInput source="code" label="Position Code" validate={required()} />
                <TextInput source="name" label="Position Name" validate={required()} />
                <ContractTypeField />
                <NumberInput onWheel={e => e.target.blur()}  source="man_months" label="Total Man Months" validate={required()} />
                <NumberInput onWheel={e => e.target.blur()}  source="rate_per_month" validate={required()} />
                <NumberInput onWheel={e => e.target.blur()}  source="total_contract_value" label="Total Amount" validate={required()} />
                <NumberInput onWheel={e => e.target.blur()}  source="escalation_rate" label="Escalation Rate" defaultValue={0} validate={required()} />
                <SelectInput source="currency" choices={[
                    { id: 'INR', name: 'INR' },
                    { id: 'USD', name: 'USD' },
                    { id: 'JPY', name: 'JPY' },
                ]} />
                <TextInput source="department" label="Department Name" />
            </FormTab>
            <FormTab label="Historical Data">
                <ReferenceInput source="history.report_month_id" reference="report_months" validate={required()} ><SelectInput optionText="name" value="id" label="Select Report of last month" fullWidth="true" /></ReferenceInput>
                <NumberInput onWheel={e => e.target.blur()}  source="history.balance_amount" label="Balance Amount till above report" validate={required()} fullWidth="true" />
                <NumberInput onWheel={e => e.target.blur()}  source="history.balance_mm" label="Balance Man Months till above report" validate={required()} fullWidth="true" />
            </FormTab>
        </TabbedForm>
    </Create>
);

const UpdateBulkEscalation = () => {
    const [updateMany, { isLoading, error }] = useUpdateMany();
    const record = useRecordContext();
    const notify = useNotify();
    const escalation = useWatch({name: 'escalation_rate'});
    const listContext = useGetList('positions', {filter: {currency: record.currency,company_id: record.company_id < 5 ?  [1,2,3,4] : [5,6,7]},pagination: {page:1, perPage: 1000}});
    const isSameValue = record.escalation_rate === escalation;
    const handleClick = () => {
        var selectedIds = [];
        if(listContext.isSuccess || listContext.data > 0){
            listContext.data.forEach((value) => selectedIds.push(value.id));
        };
        isSameValue ? notify("Change Escalation Rate Value to Update",{type: 'info'}) :
            updateMany('positions', { ids: selectedIds, data: { escalation_rate: escalation } }).then((val) =>
                notify("Updated Escalation Rate as " + escalation + " for All " + record.currency + " Positions", { type: 'success' }), (e) =>
                notify("Failed to Update Escalation for All " + record.currency + " Positions", { type: 'error' })
            );
     };
     if(error) { console.log(error);}
    return <Button disabled={isLoading} onClick={handleClick} label={"Press Here To Update Escalation Rate for All " + record.currency + " Positions"} />;
}

export const PositionEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput source="code" />
            <TextInput source="name" />
            <BooleanInput source="active" />
            <TextInput source="department" />
            <ContractTypeField />
            <NumberInput onWheel={e => e.target.blur()}  source="man_months" />
            <NumberInput onWheel={e => e.target.blur()}  source="rate_per_month" />
            <NumberInput onWheel={e => e.target.blur()}  source="total_contract_value" />
            <NumberInput onWheel={e => e.target.blur()}  source="escalation_rate" />
            <UpdateBulkEscalation />
            <ReferenceInput source="company_id" reference="companies"><SelectInput optionText="full_name" optionValue="id" /></ReferenceInput>
            <ReferenceInput source="position_category_id" reference="position_category"><SelectInput optionText="description" /></ReferenceInput>
            <SelectInput source="currency" choices={[
                    { id: 'INR', name: 'INR' },
                    { id: 'USD', name: 'USD' },
                    { id: 'JPY', name: 'JPY' },
                ]} />
        </SimpleForm>
    </Edit>
);



const ContractValueList = () => {
    const record = useListContext();
    var d = [];

    if (!(record.isLoading)) {
        var count = 0;
        record.data.forEach((value) => {
            d.forEach((val) => { if (val.contract_type === value.contract_type) count++; });
            if (count === 0) {
                d = d.concat(value);
            } else { count = 0; }
        });
        return (<Datagrid data={d} bulkActionButtons={false}>
            <ContractTypeField label="Contract Type" isView={true}/>
            <FunctionField label="Total Contract Value" render={record => Number(record.cumulative_amount) + Number(record.balance_amount)} />
            <FunctionField label="Total Man Months" render={record => Number(record.cumulative_mm) + Number(record.balance_mm)} />
        </Datagrid>);
    }

}

export const PositionShow = () => (
    <Show>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="code" />
            <TextField source="name" />
            <BooleanField source="active" />
            <TextField source="department" />
            <ContractTypeField label="Contract Type" isView={true} />
            <NumberField source="man_months" />
            <NumberField source="rate_per_month" />
            <NumberField source="total_contract_value" />
            <TextField source="escalation_rate" />
            <TextField source="currency" />
            <ReferenceField source="company_id" reference="companies"><TextField source="name" /></ReferenceField>
            <ReferenceField source="position_category_id" reference="position_categories" link="false"><TextField source="name" /></ReferenceField>
            <DateField source="createdAt" />
            <DateField source="updatedAt" />
            <ReferenceManyField label="Contract Values" reference="position_historical_data" target="position_id" sort={{field: 'id', order: 'ASC'}}>
                <ContractValueList />
            </ReferenceManyField>
        </SimpleShowLayout>
    </Show>
);

const PositionHisFilters = [
    <ReferenceInput source="position_id" reference="positions" validate={required()} alwaysOn label="Position Code"><AutocompleteInput optionText="code" optionValue="id" /></ReferenceInput>,
    <ReferenceInput source="report_month_id" reference="report_months" validate={required()} alwaysOn><AutocompleteInput optionText="name" optionValue="id" /></ReferenceInput>,
    <ContractTypeField label="Contract Type" alwaysOn/>
];

export const PositionHistoricalDataList = () => (
    <List filters={PositionHisFilters}>
        <Datagrid rowClick="show" bulkActionButtons={false}>
            <TextField source="id" validate={required()} />
            <ReferenceField source="position_id" reference="positions" label="Position Code"><TextField source="code" /></ReferenceField>
            <ReferenceField source="position_id" reference="positions" label="Position Name"><TextField source="name" /></ReferenceField>
            <ReferenceField source="report_month_id" reference="report_months" label="Report"><TextField source="name" /></ReferenceField>
            <NumberField source="cumulative_amount" />
            <NumberField source="cumulative_mm" label="Cumulative Man Months" />
            <NumberField source="balance_amount" />
            <NumberField source="balance_mm" label="Balance Man Months" />
        </Datagrid>
    </List>
);

export const PositionHistoricalDataShow = () => (
    <Show>
        <SimpleShowLayout>
            <TextField source="id" validate={required()} />
            <ReferenceField source="position_id" reference="positions" label="Position Code"><TextField source="code" /></ReferenceField>
            <ReferenceField source="position_id" reference="positions" label="Position Name"><TextField source="name" /></ReferenceField>
            <ReferenceField source="report_month_id" reference="report_months" label="Report"><TextField source="name" /></ReferenceField>
            <NumberField source="cumulative_amount" />
            <NumberField source="cumulative_mm" label="Cumulative Man Months" />
            <NumberField source="balance_amount" />
            <NumberField source="balance_mm" label="Balance Man Months" />
            <NumberField source="escalation" />
            <NumberField source="till_escalation" label="Escalation Till Above Month " />
            <TextField source="remarks" />
        </SimpleShowLayout>
    </Show>
);

export const PositionHistoricalDataEdit = () => (
    <Edit>
        <SimpleForm>
            Position Code: <ReferenceField source="position_id" reference="positions" label="Position Code"><TextField source="code" /></ReferenceField> <br />
            Position Name: <ReferenceField source="position_id" reference="positions" label="Position Name"><TextField source="name" /></ReferenceField> <br />
            Report: <ReferenceField source="report_month_id" reference="report_months" label="Report"><TextField source="name" /></ReferenceField> <br />
            <NumberInput onWheel={e => e.target.blur()}  source="balance_amount" label="Balance Amount till above report" validate={required()} fullWidth="true" />
            <NumberInput onWheel={e => e.target.blur()}  source="balance_mm" label="Balance Man Months till above report" validate={required()} fullWidth="true" />
            <NumberInput onWheel={e => e.target.blur()}  source="cumulative_amount" label="Cumulative Amount till above report" validate={required()} fullWidth="true" />
            <NumberInput onWheel={e => e.target.blur()}  source="cumulative_mm" label="Cumulative Man Months till above report" validate={required()} fullWidth="true" />
            <NumberInput onWheel={e => e.target.blur()}  source="till_escalation" label="Escalation Amount till above report" validate={required()} fullWidth="true" />
            <TextInput source="remarks"  fullWidth/>
        </SimpleForm>
    </Edit>
);

export const PositionHistoricalDataCreate = () => (
    <Create>
        <SimpleForm>
            <ReferenceInput source="position_id" reference="positions" validate={required()} ><AutocompleteInput optionText="code" optionValue="id" /></ReferenceInput>
            <ReferenceInput source="report_month_id" reference="report_months" validate={required()} ><SelectInput optionText="name" value="id" label="Select Report of last month" fullWidth="true" /></ReferenceInput>
            <NumberInput onWheel={e => e.target.blur()}  source="balance_amount" label="Balance Amount till above report" validate={required()} fullWidth="true" />
            <NumberInput onWheel={e => e.target.blur()}  source="balance_mm" label="Balance Man Months till above report" validate={required()} fullWidth="true" />
        </SimpleForm>
    </Create>
);


export const Position_categoryList = () => (
    <List>
        <Datagrid bulkActionButtons={false}>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="description" />
            <TextField source="key" />
        </Datagrid>
    </List>
);